import { render, staticRenderFns } from "./DailyMonthlySensorValueTable.vue?vue&type=template&id=613587e2"
import script from "./DailyMonthlySensorValueTable.vue?vue&type=script&lang=js"
export * from "./DailyMonthlySensorValueTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports